var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"shallow-card p-3"},[_c('timeline-container',{attrs:{"matches":_vm.flatten.filter(Boolean).flat(1)},on:{"select":function($event){return _vm.$emit('select', $event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }